import {currentDocument} from "./browser";


export function getCookie(cname: string) {
    if (currentDocument.cookie) {
        const name = `${cname}=`;
        const decodedCookie: string = decodeURIComponent(currentDocument.cookie);
        const ca: string[] = decodedCookie.split(';');
        for(let i = 0; i <ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) == ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) == 0) {
                return c.substring(name.length, c.length);
            }
        }
    }
    return "";
}


export function deleteCookie(cname: string) {
    const date = new Date();
    // Set it expire in -1 days
    date.setTime(date.getTime() + (-1 * 24 * 60 * 60 * 1000));
    // Set it
    document.cookie = cname+"=; expires="+date.toUTCString()+"; path=/";
}

export function saveCookie(cname: string, dataToSave: any) {
    const d = new Date();
    // d.setDate(d.getDate() + 365 * 10); // 10 years
    d.setTime(d.getTime() + (72 * 60 * 60 * 1000)); // 72 hours
    document.cookie = `${cname}=${encodeURIComponent(JSON.stringify(dataToSave))};expires=${d.toUTCString()};path=/`;
}

export function saveUTMSourceCookie(utm_source: string) {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    document.cookie = `adcoreUtmSourceToken=${utm_source};expires=${d.toUTCString()};path=/`;
}


// WEBPACK FOOTER //
// ./src/lib/cookies.ts